import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';
import theme from 'theme';
import { calcSizeForTv } from 'utils/index';

export const BackGroundImageView = styled.ImageBackground`
  flex: 1;
  padding: 15px 25px;
  align-items: center;
  justify-content: center;
  background-color: rgba(22, 18, 51, 0.3);
`;

export const tvStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#070D31',
  },
  loadingContainer: {
    backgroundColor: 'transparent',
    flex: 1,
    height: '100%',
    width: '100%',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mainContent: {
    width: '100%',
    paddingHorizontal: calcSizeForTv(192),
  },
  logo: {
    width: calcSizeForTv(290),
    height: calcSizeForTv(82),
  },
  contentRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 10,
    alignItems: 'center',
    marginTop: calcSizeForTv(32),
  },
  leftSection: {
    marginRight: calcSizeForTv(80),
  },
  descriptionText: {
    color: 'white',
    fontSize: calcSizeForTv(44),
    maxWidth: calcSizeForTv(837),
    lineHeight: calcSizeForTv(52),
    marginVertical: calcSizeForTv(48),
    fontWeight: 'bold',
  },
  infoContainer: {
    borderRadius: 16,
    padding: calcSizeForTv(40),
    maxWidth: calcSizeForTv(775),
    backgroundColor: 'rgba(217, 217, 217, 0.07)',
    justifyContent: 'center',
  },
  infoRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: calcSizeForTv(16),
  },
  numberContainer: {
    width: calcSizeForTv(65),
  },
  numberText: {
    fontFamily: theme.fonts.inter.bold,
    fontSize: calcSizeForTv(48),
    lineHeight: calcSizeForTv(48),
    color: 'white',
  },
  infoText: {
    color: 'white',
    fontSize: calcSizeForTv(24),
    fontFamily: theme.fonts.inter.bold,
    lineHeight: calcSizeForTv(44),
  },
  blueText: {
    color: '#6486ff',
  },
  divider: {
    width: calcSizeForTv(7),
    height: '100%',
    minHeight: calcSizeForTv(60),
    marginHorizontal: calcSizeForTv(32),
    backgroundColor: '#6486ff',
  },
  rightSection: {
    alignItems: 'center',
    width: calcSizeForTv(380),
  },
  qrCodeContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: calcSizeForTv(20),
  },
  qrCodeWrapper: {
    borderRadius: 8,
    overflow: 'hidden',
  },
  qrCode: {
    width: calcSizeForTv(380),
    height: calcSizeForTv(380),
  },
  codeText: {
    color: '#FFFFFF',
    fontSize: calcSizeForTv(32),
    lineHeight: calcSizeForTv(44),
    fontFamily: theme.fonts.inter.bold,
    marginTop: calcSizeForTv(16),
  },
  buttonContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: calcSizeForTv(16),
    lineHeight: calcSizeForTv(24),
    fontFamily: theme.fonts.inter.bold,
    marginLeft: calcSizeForTv(10),
  },
});
